/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 修正情報
 */
export interface Sgkb981aResSyuseiInfoDto {
    /**
     * 契約お客さま番号：数字
     */
    firstSrvctrNo?: string;
    /**
     * サービス契約番号：数字
     */
    srvCtrNo?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
    /**
     * 契約締結組織番号：英数字
     */
    tantoSosikiId?: string;
    /**
     * 契約締結社員番号：英数字
     */
    tantoStaffNo?: string;
    /**
     * お客さま契約窓口担当部署：全半角混在
     */
    visitMadoguchiTantobusho?: string;
    /**
     * お客さま契約窓口担当者：全半角混在
     */
    visitMadoguchiTntsh?: string;
    /**
     * お客さま契約窓口電話番号：半角
     */
    visitMadoguchiTelno?: string;
    /**
     * 契約開始日付：日付(yyyyMMdd)
     */
    ctrstrDate?: string;
    /**
     * 満了予定年月：日付(yyyyMM)
     */
    expireScheduleyearmonth?: string;
    /**
     * 契約終了日付：日付(yyyyMMdd)
     */
    ctrendDate?: string;
    /**
     * サービス契約締結日付：日付(yyyyMMdd)
     */
    prdCtrDate?: string;
    /**
     * 契約書受領日：日付(yyyyMMdd)
     */
    ctrdocReceiptdate?: string;
    /**
     * 冷房能力：数字
     */
    reiboability?: number;
    /**
     * 発電容量：数字
     */
    powergenerationcapacity?: number;
    /**
     * 定格入力値（合計）：数字
     */
    ratedinputvalueSum?: number;
    /**
     * 空調：boolean
     */
    airconditioning?: boolean;
    /**
     * 機器定格：boolean
     */
    deviceTeikaku?: boolean;
    /**
     * 基本契約締結日：日付(yyyyMMdd)
     */
    basiccontractdocumentConclusiondate?: string;
    /**
     * 基本契約書受領日付：日付(yyyyMMdd)
     */
    basiccontractdocumentReceiptdate?: string;
    /**
     * 独自管理対象個別コード：数字
     */
    independentmanagementTargetIndividualcode?: string;
    /**
     * 調整単位料金おしらせ発行フラグ：数字
     */
    adjustmentunitfeeNoticeHakkoflag?: string;
    /**
     * 関連会社区分：英数字
     */
    relatedcompanyDiv?: string;
    /**
     * 関連会社お客さま番号：英数字
     */
    relatedcompanyVisitornumber?: string;
}

